/* angular:styles/component:css;197c8c6175daa2215ce75f6fb574b885e134ca81e08ff35ebe23c8286772961f;/codebuild/output/src4169523549/src/friggkantine-admin/src/app/admin-dashboard/parent-refunds/parent-refunds.component.ts */
.pr-wrap {
  padding: 16px;
}
.pr-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.pr-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 720px;
}
.pr-spacer {
  flex: 1 1 auto;
}
.pr-state {
  padding: 28px;
  text-align: center;
  color: #888;
}
.pr-error {
  color: #c0392b;
}
.pr-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 13px;
}
.pr-table th,
.pr-table td {
  text-align: left;
  padding: 10px 12px;
  border-bottom: 1px solid #eef0f2;
  vertical-align: top;
}
.pr-table th {
  color: #888;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}
.num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
}
.pr-muted {
  color: #888;
  font-size: 12px;
}
.pr-reason {
  max-width: 260px;
  white-space: pre-wrap;
}
.pr-actions {
  white-space: nowrap;
  text-align: right;
}
.pr-actions button {
  margin-left: 6px;
}
.pr-chip {
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
  white-space: nowrap;
}
.pr-chip-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.pr-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.pr-chip-wait {
  background: #fff4e0;
  color: #8a5a12;
}
/*# sourceMappingURL=parent-refunds.component.css.map */
